module.exports = __webpack_public_path__ + "b2529a829d8cc1e94d483a7cd7eae3ca.svg";